// 标记位置类型
export const SOURCE_POSITION_TYPE = {
  IN: 1,
  OUT: 2,
};
